import initialState from './initialState';
import { combineReducers } from 'redux';
import { reducer as oidcReducer } from 'redux-oidc';
import ajaxCallsInProgress from './ajaxStatusReducer';
import assetDataReducer from 'features/offer/edit/assets/asset/reducers/assetDataReducer';
import clientDataReducer from 'features/offer/edit/client/form/reducers/clientDataReducer';
import currentOfferReducer from './currentOffer/currentOfferReducer';
import notificationReducer from './notificationReducer';
import asyncCommandReducer from './asyncCommandReducer';
import dictionariesReducer from './dictionariesReducer';
import offerConfigReducer from './offerConfigReducer';
import userInfoReducer from './userInfoReducer';
import dashboardReducer from './dashboardReducer';
import snackbarReducer from './snackbarReducer';
import tasksReducer from 'features/tasks/reducer';
import offerVisibilityReducer from './offerVisibilityReducer';
import folderVisibilityReducer from '../features/folder/list/folderVisibilityReducer';
import entitiesReducer from 'features/common/reducers/entitiesReducer';
import reportsReducer from './reportsReducer';
import facilityReducer from 'features/facility/facilityReducer';
import brandingReducer from 'features/settings/dealerBranding/reducer';
import { withFilterOnDocumentIdAndSiteId } from 'reducers/withFilterOnDocumentIdAndSiteId';
import currentFolderReducer from 'features/folder/currentFolderReducer';
import assetReducer from 'features/asset/assetReducer';
import documentReducer from 'features/document/documentReducer';
import globalParamsReducer from 'features/params/globalParams/reducer';
import globalRightsReducer from 'features/globalRights/reducer';
import applicationFeaturesReducer from 'features/applicationFeatures/reducers/reducer';
import documentRightsReducer from './documentRightsReducer';
import userProfileReducer from 'features/userProfile/userProfileReducer';
import serverEventReducer from './serverEventReducer';
import simulatorDataReducer from 'features/simulator/reducer';
import offersReducer from 'features/offer/edit/responsibleChange/reducers/reduxReducer';
import responsibleChangeFoldersReducer from 'features/folder/edit/allocateResponsible/reduxReducer';
import { genericFilterParamReducer } from '../features/genericFilters/reducers/reducerFilterParam';
import { genericFilterOperatorReducer } from '../features/genericFilters/reducers/reducerFilterOperator';
import { genericFilterParamValuesReducer } from '../features/genericFilters/reducers/reducerFilterParamValues';
import * as actionTypes from 'actions/actionTypes';
import { OFFER_SUBSIDIES_COMPUTED } from 'features/offer/edit/financials/commissions/eventTypes';
import partnerFilesReducer from 'features/partnerFile/reducers';

function legacyReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.LANGUAGE_CHANGED: {
      return {
        ...initialState,
        params: state.params,
        oidc: state.oidc,
        globalRights: state.globalRights,
        userInfo: state.userInfo,
        facilities: state.facilities,
        dashboard: state.dashboard,
        tasksData: state.tasksData,
        offerVisible: state.offerVisible,
        folderVisible: state.folderVisible,
        partnerFiles: state.partnerFiles,
        reports: state.reports,
        offerConfig: state.offerConfig
      };
    }

    case OFFER_SUBSIDIES_COMPUTED: {
      const key = `${action.event.eventBody.documentId}-${action.event.eventBody.siteId}`;
      return {
        ...state,
        currentOffer: {
          ...state.currentOffer,
          commissions: {
            ...state.currentOffer.commissions,
            [key]: {
              loading: false,
              loaded: false,
              saving: { subsidies: false, commissions: false }
            }
          }
        }
      };
    }

    default:
      return state;
  }
}

const combinedSlicesReducer = combineReducers({
  entities: entitiesReducer,
  oidc: oidcReducer,
  assetData: assetDataReducer,
  clientData: clientDataReducer,
  currentOffer: withFilterOnDocumentIdAndSiteId(currentOfferReducer),
  ajaxCallsInProgress,
  notifications: notificationReducer,
  pendingAsyncCommands: asyncCommandReducer,
  dictionaries: dictionariesReducer,
  offerConfig: offerConfigReducer,
  userInfo: userInfoReducer,
  params: globalParamsReducer,
  globalRights: globalRightsReducer,
  applicationFeatures: applicationFeaturesReducer,
  documentRights: documentRightsReducer,
  dashboard: dashboardReducer,
  snackbar: snackbarReducer,
  offerVisible: offerVisibilityReducer,
  folderVisible: folderVisibilityReducer,
  partnerFiles: partnerFilesReducer,
  reports: reportsReducer,
  currentFolder: withFilterOnDocumentIdAndSiteId(currentFolderReducer),
  asset: assetReducer,
  document: documentReducer,
  tasksData: tasksReducer,
  userProfile: userProfileReducer,
  serverEvents: serverEventReducer,
  simulatorData: simulatorDataReducer,
  facilities: facilityReducer,
  responsibleChangeOffers: offersReducer,
  responsibleChangeFolders: responsibleChangeFoldersReducer,
  genericFilterParams: genericFilterParamReducer,
  genericFilterOperators: genericFilterOperatorReducer,
  genericFilterParamValues: genericFilterParamValuesReducer,
  dealerBranding: brandingReducer
});

export default function reducers(state = initialState, action) {
  const intermediateState = legacyReducer(state, action);
  const finalState = combinedSlicesReducer(intermediateState, action);
  return { ...intermediateState, ...finalState };
}
